  <template >
   <div class="formPosition" v-role="roles">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col>

<div class="text-center">
<v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
 <v-container fluid>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline">Correção de Finalistas não transita</v-list-item-title>
        <v-list-item-subtitle>Listagem dos Estudantes</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="12">
    <v-card-text>
      <strong> Estudantes</strong>
      <v-row>
          <v-col md="6"></v-col>
          <v-col md="4">
            <v-text-field
              v-model="searchInDb"
              append-icon="search"
              label="Pesquisa"

              single-line
              hide-details
          ></v-text-field>
          </v-col>
          <v-col md="2">
            <v-btn   @click="AlunosFinalistasComDisciplinasErradas()" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          </v-col>
      </v-row>
    </v-card-text>
    <hr>
    <v-row>
      <v-col md="12">
       <v-list dense>
       <v-list-item-group
          color="primary"
        >
        <v-list-item
          v-for="(item, i) in estudantes"
          :key="i"
        >
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{item.nome}}</v-list-item-title>
          </v-list-item-content>
           <v-list-item-content>
            <v-list-item-title>{{item.instituicaodescricao}}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon  @click="ListarDisciplinas(item)" v-bind="attrs" v-on="on">view_list</v-icon>
            </template>
            <span>Ver disciplinas incorrectas</span>
          </v-tooltip>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
      </v-col>
    </v-row>
  </v-col>
</v-row>
  </v-card>

  <!-- ================== DIALOGO DA LISTAGEM DE DISCIPLINAS =========================================== -->

  <v-dialog
      v-model="dialog"
      persistent
      max-width="590"
    >
      <v-card>
        <v-card-title class="headline">
          Estudante:
        </v-card-title>
        <v-card-text>

            <v-row>
              <v-col md="12">

                   <v-list dense>
                     <v-subheader>disciplinas incorrectas</v-subheader>
       <v-list-item-group
          color="primary"
        >
        <v-list-item
          v-for="(item, i) in disciplinas"
          :key="i"
        >
                <v-list-item-icon>
                  <v-icon></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{item.desc_disc}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title>{{item.classe}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon  @click="EliminarDisciplina(item)" v-bind="attrs" v-on="on" style="color:red">delete</v-icon>
                  </template>
                  <span>Eliminar disciplina</span>
                </v-tooltip>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
            </v-list>

              </v-col>

            </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <!-- ================================================================================================= -->

  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    overlay: false,
    roles: 'func',
    estudantes: [],
    disciplinas: [],
    searchInDb: '',
    dialog: false,
    select2: null,
    select1: null,
    pesquisa_parameto: null,
    estudanteObj: null,
    estudante_dados: [],
    disabilita_ano: true,
    funcionarios: [],
    select_anolectivo: null,
    idMatricula: null,
    estudante: true,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    selectedItem: 1,
    items: [
      { text: 'Real-Time', icon: 'mdi-clock' },
      { text: 'Audience', icon: 'mdi-account' },
      { text: 'Conversions', icon: 'mdi-flag' }
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'idAno_Academico' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.AlunosFinalistasComDisciplinasErradas()
    // check if classe has been selected otherwise send back to painel to select
  },
  methods: {

    async AlunosFinalistasComDisciplinasErradas () {
      if (!this.searchInDb) {
        var payload = '{"find":"all"}'
      } else {
        payload = '{"find":"' + this.searchInDb + '"}'
      }
      try {
        this.overlay = true
        this.estudantes = await axios
          .get('/finalistas-disciplinas-erradas/' + payload)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }
    },

    ListarDisciplinas (item) {
      this.ObterDisciplinasIncorrectas(item).then(() => {
        // this.estudanteObj = item.nome
        this.dialog = true
      })
    },

    async  ObterDisciplinasIncorrectas (item) {
      try {
        this.overlay = true
        this.disciplinas = await axios
          .get('/finalistas-disciplinas-erradas-listagem/' + item.idMatricula)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }
    },

    async EliminarDisciplina (item) {
      try {
        this.overlay = true
        let msg = await axios
          .get('/finalistas-disciplinas-erradas-eliminar/' + item.pkPauta)
          .then(res => res.data)
        if (msg.affectedRows >= 1) {
          const index = this.disciplinas.indexOf(item)
          this.disciplinas.splice(index, 1)
        }
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }
    },

    SelecionaEntidade () {
      if (this.select1 !== 'Aluno') {
        this.estudante = false
        this.disabilita_ano = true
        this.CarregaFuncionario()
      } else {
        this.disabilita_ano = false
        this.estudante = true
      }
    },

    async CarregaAlunos () {
      if (this.select_anolectivo != null) {
        try {
          this.progresso = true
          this.Pessoas = await axios
            .get('/pessoaFind/' + this.select_anolectivo)
            .then(res => res.data)
          this.progresso = false
          console.log(this.Pessoas)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async SelecionaAluno () {
      if (this.pesquisa_parameto != null) {
        // CarregaInscrição na turma
        try {
          this.estudante_dados = await axios
            .get('/InscricaoTurma/' + this.pesquisa_parameto.idMatricula)
            .then(res => res.data)
          console.log(this.estudante_dados)
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async CarregaFuncionario () {
      let payload = '{"find":"all"}'
      try {
        this.funcionarios = await axios
          .get('/funcionarioPessoaFindAll/' + payload)
          .then(res => res.data)
        console.log(this.funcionarios)
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
